export const EVENT_INFO_TAB = 'event-info';
export const COMPANY_INFO_TAB = 'company-info';
export const SETTINGS_TAB = 'settings';
